import { useQuery } from 'react-query';
import { get } from '../../../../api/fetch';

interface IAlpInformationPage {
  path: string;
  slices?: ISlice[];
}

const getAlpInformationPage = () =>
  new Promise<IAlpInformationPage>((resolve, reject) => {
    get<ISiteContext>(`/inspiration/prisvarda-favoriter?o=json`)
      .then((context) => {
        resolve({
          path: '/inspiration/prisvarda-favoriter',
          slices: context.cells['main'].data.body.filter(
            (item: ISlice) => item.sliceType !== 'productListing',
          ) as ISlice[],
        } as IAlpInformationPage);
      })
      .catch(reject);
  });

export default () => {
  return useQuery(['alp-info-panel'], () => getAlpInformationPage(), {
    useErrorBoundary: true,
    suspense: true,
    retry: false,
  });
};
